export default {
  name: "Mail",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 4H4c-1.16 0-2 .84-2 2v20c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V6c0-1.16-.84-2-2-2zM12.05 16.93c1.01.68 2.38 1.07 3.75 1.07h.5c1.29 0 2.58-.36 3.74-1.06l.72-.46L26.81 26H5.19l6.08-9.56.78.49zM28 6l.01 3.45-9.02 5.79c-.83.5-1.76.76-2.69.76h-.5c-.97 0-1.96-.27-2.66-.74L4 9.45V6h24zm.01 5.82.03 12.39-5.61-8.81 5.58-3.58zM9.58 15.37 4 24.14V11.82l5.58 3.55z",
  },
}
